import { useApolloClient } from '@apollo/client';
import { ZipCodesFindOneQuery } from 'graphql/generated';
import { ZipCodeObject } from 'redux/search-param.slice';

import { ZIP_CODE_FIND_ONE_QUERY } from '../data/ZipCodeFindOneQuery.graphql';

export const useZipCodeObjectData = () => {
  const client = useApolloClient();

  const findOne = async (code: string) => {
    const result = await client.query<ZipCodesFindOneQuery>({
      query: ZIP_CODE_FIND_ONE_QUERY,
      variables: { filters: [{ field: 'code', strVal: code }] },
    });
    if (result?.data?.zipCodesFindOne) {
      const { __typename, ...zipCodeObject } = result.data.zipCodesFindOne;
      return zipCodeObject as ZipCodeObject;
    }
  };

  return {
    findOne,
  };
};
